var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import styled from "styled-components";
export var Svg = styled("svg")(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  flex-shrink: 0;\n  vertical-align: middle;\n  fill: currentColor;\n  width: ",
      ";\n  height: ",
      ";\n  color: ",
      ";\n",
    ])),
  function (props) {
    return props.width || "25px";
  },
  function (props) {
    return props.height || "25px";
  },
  function (props) {
    return props.color || "inherit";
  }
);
